import { render, staticRenderFns } from "./InputMultiSelectTags.vue?vue&type=template&id=fd74c78a&"
import script from "./InputMultiSelectTags.vue?vue&type=script&lang=js&"
export * from "./InputMultiSelectTags.vue?vue&type=script&lang=js&"
import style0 from "./InputMultiSelectTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports